import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";
import Server from '../../../functions/server';
import { Grid } from 'semantic-ui-react';

class ViewCreditOrderDetails extends React.Component {
  state = {
    fullWidth: true,
    maxWidth: 'xl', creditOrderDetails: [], maxWidth1: 'xs',
  }

  getCreditOrder() {
    let context = this;
    $.ajax({
      type: 'POST',
      data: { 'id': context.props.id },
      url: Server() + 'invoice/getCreditOrderDetails.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          console.log(data);
          context.setState({ creditOrderDetails: data, load: false, openCreditOrderDetailsDialog: true })
        } catch (error) {
          alert('Error!!!')
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false })
      }
    });
  }

  cancelCreditNoteDetails(id) {
    if (!this.props.menuPermission.cancel) {
      alert('You Are Not Allow To Cancel!!!');
      return;
    }
    this.setState({ cancelId: id, openCancelConfirmationDialog: true })
  }

  cancel() {
    let context = this;
    context.setState({  load: true, message: 'Cancel Credit Note!!!' })
    $.ajax({
      type: 'POST', url: Server() + 'invoice/cancelitem.php',
      data: { 'id': context.state.cancelId },
      success: function(data) {
        console.log(data);
        if (data == 1) {
          let creditOrderDetails = context.state.creditOrderDetails;
          let newcreditOrderDetails = [];
          creditOrderDetails.map((c) => {
            if (c.id != context.state.cancelId) {
              newcreditOrderDetails.push(c);
            }
          })
          context.setState({ creditNotes: newcreditOrderDetails, openCancelConfirmationDialog: false })
        }
        else {
          alert('Failed!!!');
          context.setState({ load: false, openCancelConfirmationDialog: false })
        }
      },
      error: function(e) {
        alert('Try again!!');
        context.setState({ load: false });
      }
      });
  }

  render() {
    let i = 1;
    return (
      <div>
        <div style={{color: 'blue'}} onClick={this.getCreditOrder.bind(this)}>View</div>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}  open={this.state.openCreditOrderDetailsDialog}
          onClose={ () => { this.setState({ openCreditOrderDetailsDialog: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">{this.props.credit_voucher}</DialogTitle>
          <DialogContent>
            <table id="table" width="100%">
              <tr id="th">
                <th>Sino</th>
                <th>Partno</th>
                <th>Spare Name</th>
                <th>Qty</th>
                <th>Disc (%)</th>
                <th>Disc (Rs)</th>
                <th>Total</th>
                <th>Cancel</th>
              </tr>
              {
                this.state.creditOrderDetails.map((c) => {
                  return (
                    <tr>
                      <td>{i++}</td>
                      <td>{c.partno}</td>
                      <td>{c.spare_name}</td>
                      <td>{c.qty}</td>
                      <td>{c.disc}</td>
                      <td>{c.disrs}</td>
                      <td>{c.totprice}</td>
                      <td onClick={this.cancelCreditNoteDetails.bind(this, c.id)}>
                        <center style={{color: 'red'}}>
                          Cancel
                        </center>
                      </td>
                    </tr>
                  )
                })
              }
            </table>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ openCreditOrderDetailsDialog: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth1}  open={this.state.openCancelConfirmationDialog}
          onClose={ () => { this.setState({ openCancelConfirmationDialog: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">{'Confimation'}</DialogTitle>
          <DialogContent>
            Are Sure to Remove this Item?<br/><br/>
            <Grid>
              <Grid.Column mobile={16} computer={8} tablet={16}>
                <Button negative fullWidth onClick={ () => { this.setState({ openCancelConfirmationDialog: false }) }}>NO</Button>
              </Grid.Column> 
              <Grid.Column mobile={16} computer={8} tablet={16}>
                <Button positive fullWidth onClick={this.cancel.bind(this)}>YES</Button>
              </Grid.Column> 
            </Grid>
          </DialogContent>
        </Dialog>


      </div>
    );
  }
}

export default ViewCreditOrderDetails;
